var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnmute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6827 12.7258V2.81037C14.6827 2.18036 14.2113 1.66666 13.5534 1.66666C13.0821 1.66666 12.7875 1.87989 12.267 2.33544L7.97584 6.09612L9.02655 7.14291L12.8562 3.71177C12.9053 3.66331 12.9642 3.63423 13.0232 3.63423C13.0919 3.63423 13.1508 3.68269 13.1508 3.76993V11.2138L14.6827 12.7258ZM17.8741 19.7819C18.1687 20.0727 18.6596 20.0727 18.9444 19.7819C19.239 19.4814 19.239 19.0162 18.9444 18.7254L2.13314 2.1319C1.83855 1.84112 1.34756 1.84112 1.05297 2.1319C0.758384 2.41298 0.758384 2.90729 1.05297 3.18838L17.8741 19.7819ZM4.79427 14.1506H7.6027C7.69107 14.1506 7.76963 14.1797 7.83837 14.2378L12.267 18.1536C12.7482 18.5703 13.1017 18.7642 13.5731 18.7642C13.956 18.7642 14.2703 18.5897 14.4961 18.2602L13.357 17.1456L8.61412 12.9487C8.41773 12.7742 8.29989 12.7355 8.04458 12.7355H4.86301C4.48986 12.7355 4.32293 12.5707 4.32293 12.2121V8.21878L3.14456 7.05568C2.91871 7.36584 2.79106 7.802 2.79106 8.37386V12.0861C2.79106 13.4915 3.45879 14.1506 4.79427 14.1506Z",
    fill: "#9C85F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmute);
export default __webpack_public_path__ + "static/media/unmute.3290b24efdbfbebbc5e2fb84e93953b3.svg";
export { ForwardRef as ReactComponent };